import {
  IonCol,
  IonContent,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonRow,
  IonText,
  IonToast,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { makePATCHRequest } from "../../request/rawRequest";
import LogoLogin from "../Login/LogoLogin";

interface Props {
  pathLogo: string;
}

const ForgotPassword: React.FC<Props> = ({ pathLogo }) => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [showToast, setShowToast] = useState<boolean>(false);
  const locationL = useLocation();
  const params = new URLSearchParams(locationL.search);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
    if (!passwordRegex.test(password)) {
      setError(
        "Le mot de passe doit faire 8 caractères de long, et contenir une majuscule, une minuscule et un chiffre"
      );
      setShowToast(true);
      return;
    }
    if (password !== confirmPassword) {
      setError("Les mots de passe ne sont pas les mêmes");
      setShowToast(true);
      return;
    }

    try {
      makePATCHRequest("/password?email=" + params.get("email"), {
        value:
          "?value=" + params.get("value") + "&email=" + params.get("email"),
        password: password,
      })
        .then((response) => {
          window.location.href = "/";
        })
        .catch((error) => {
          setError(error.response.data.status);
          setShowToast(true);
        });
    } catch (err: any) {}
  };

  useEffect(() => {
    if (!params.get("email") || !params.get("value")) {
      window.location.href = "/";
    }
    setEmail(params.get("email") || "");
  }, []);

  return (
    <IonPage>
      {/* display error if had */}
      {showToast && (
        <IonToast
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          message={error}
          position="top"
          color="danger"
          duration={2000}
        />
      )}

      <IonContent color="primary">
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <IonRow className="ion-justify-content-center">
                <IonCol size-lg="3" size="6" size-sm="6">
                  <LogoLogin path={pathLogo} />

                  {/* <IonImg
                    src={pathLogo}
                    alt="loginImage"
                    className="loginImg"
                  /> */}
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <IonRow className="ion-justify-content-center">
                <IonCol size="12" size-sm="12" size-lg="10">
                  <IonRow className="ion-justify-content-center">
                    <IonText color="black" className="ion-text-center">
                      <h1>Mot de passe perdu</h1>
                      <h5>
                        Veuillez entrer votre email et un nouveau mot de passe
                      </h5>
                    </IonText>
                  </IonRow>

                  <IonRow class="ion-justify-content-center">
                    <IonCol size="12" size-sm="12" size-lg="8">
                      <IonItem color="transparent">
                        <IonLabel color="black" position="floating">
                          Email
                        </IonLabel>
                        <IonInput
                          name="email"
                          type="email"
                          value={email}
                          onIonChange={(e) => setEmail(e.detail.value!)}
                          required
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  <IonRow class="ion-justify-content-center">
                    <IonCol size="12" size-sm="12" size-lg="8">
                      <IonItem color="transparent">
                        <IonLabel color="black" position="floating">
                          Mot de passe
                        </IonLabel>
                        <IonInput
                          name="email"
                          type="password"
                          value={password}
                          onIonChange={(e) => setPassword(e.detail.value!)}
                          required
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  <IonRow class="ion-justify-content-center">
                    <IonCol size="12" size-sm="12" size-lg="8">
                      <IonItem color="transparent">
                        <IonLabel color="black" position="floating">
                          Confirmation du mot de passe
                        </IonLabel>
                        <IonInput
                          name="email"
                          type="password"
                          value={confirmPassword}
                          onIonChange={(e) =>
                            setConfirmPassword(e.detail.value!)
                          }
                          required
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonCol>
              </IonRow>

              <IonRow
                className="ion-justify-content-center"
                style={{ paddingBottom: "30px", paddingTop: "30px" }}
              >
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonItem color="transparent">
                    <IonText className="btn btn-shade" onClick={handleSubmit}>
                      Enregistrer votre nouveau mot de passe
                    </IonText>
                  </IonItem>
                </IonCol>
              </IonRow>

              <IonRow className="ion-justify-content-center">
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonItem color="transparent">
                    <IonText
                      className="btn btn-shade"
                      onClick={() =>
                        (window.location.href =
                          "techno/login?" +
                          (new URLSearchParams(window.location.search).get(
                            "premium"
                          ) !== null
                            ? "premium=true"
                            : ""))
                      }
                    >
                      Pas encore de compte ?
                    </IonText>
                  </IonItem>
                </IonCol>
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonItem color="transparent">
                    <IonText
                      class="btn btn-login"
                      onClick={() => (window.location.href = "login")}
                    >
                      Se Connecter
                    </IonText>
                  </IonItem>
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
    // <IonPage>
    //   <IonHeader>
    //     <IonToolbar>
    //       <IonTitle>Forgot Password</IonTitle>
    //     </IonToolbar>
    //   </IonHeader>
    //   <IonContent className="ion-padding">
    //     <div style={{ display: "flex", justifyContent: "center" }}>
    //       <form
    //         style={{
    //           width: "40%",
    //           height: "70%",
    //           maxHeight: "500px",
    //           backgroundColor: "white",
    //           padding: "20px",
    //           boxShadow: "0px 0px 10px #999",
    //           borderRadius: "10px",
    //           display: "flex",
    //           flexDirection: "column",
    //           alignItems: "center",
    //         }}
    //         onSubmit={handleSubmit}
    //       >
    //         {error && (
    //           <IonAlert
    //             isOpen={showAlert}
    //             onDidDismiss={() => setShowAlert(false)}
    //             message={error}
    //             buttons={["OK"]}
    //           />
    //         )}
    //         <IonItem>
    //           <IonLabel position="floating">Email</IonLabel>
    //           <IonInput
    //             type="email"
    //             required
    //             value={email}
    //             onIonChange={(e) => setEmail(e.detail.value!)}
    //           />
    //         </IonItem>
    //         <IonItem>
    //           <IonLabel position="floating">Password</IonLabel>
    //           <IonInput
    //             type="password"
    //             required
    //             value={password}
    //             onIonChange={(e) => setPassword(e.detail.value!)}
    //           />
    //         </IonItem>
    //         <IonItem>
    //           <IonLabel position="floating">Confirm Password</IonLabel>
    //           <IonInput
    //             type="password"
    //             required
    //             value={confirmPassword}
    //             onIonChange={(e) => setConfirmPassword(e.detail.value!)}
    //           />
    //         </IonItem>
    //         <IonButton type="submit">Submit</IonButton>
    //       </form>
    //     </div>
    //   </IonContent>
    // </IonPage>
  );
};

export default ForgotPassword;
